import { createSelector } from "@reduxjs/toolkit";
import { selectMatchedResults } from "./facets/select-matched-results";

/** Returns the count of available homes in the facet matched results */
export const selectAvailableHomeCount = createSelector(
	[selectMatchedResults],
	(matchedResults) => {
		let count = 0;

		matchedResults?.forEach((result) => {
			count += result.availableHomes;
		});

		return count;
	},
);
